import React, { memo } from 'react';
import { CheckCircle } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="bg-white py-10 md:py-14 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-6 font-['Oswald'] uppercase" data-id="element-3">
          👨‍👩‍👧 Esto es para ti si…
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg mx-auto" data-id="element-4">
          {['Tu hijo hace muchas preguntas', 'Quieres que entienda y no solo memorice', 'Buscas una forma más simple de enseñarle', 'Quieres estimular su inteligencia desde pequeño'].map((item, idx) => <div key={idx} className="flex items-center gap-3 bg-green-50 p-4 rounded-lg border border-green-200 text-left" data-id="element-5">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-6" />
              <span className="text-sm font-semibold text-gray-800" data-id="element-7">
                {item}
              </span>
            </div>)}
        </div>

        <div className="mt-8" data-id="element-8">
          <a href="#compra" className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg font-black py-4 px-8 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase inline-flex items-center justify-center gap-2 no-underline" data-id="element-9">
            🚀 Quiero acceder ahora
          </a>
        </div>
      </div>
    </section>;
}